const Validation = {
    install(Vue, options) {
        Vue.prototype.$validation = {
            create: Validation.create
        }
    },
    create(fields) {
        _.each(fields, function (rules, field) {
            _.each(rules, function (rule, idx) {
                if (_.isString(rule)) {
                    fields[field][idx] = Validation.parseRule(rule);
                }
            })
        });
        return fields;
    },
    parseRule(rule) {
        //match name:params:msg pattern. All ':' in params must be escaped using '\'
        let matches = rule.match(/([^:]+)(?::(.*?[^\\])(?=:|$)(?::(.*))?)?$/);
        if (!matches || _.isEmpty(matches)) {
            console.error('Unable to parse rule: ' + rule);
        }

        let name = matches[1];
        let params = matches[2];
        let msg = matches[3];
        if (!_.has(Validation.rules, name)) {
            console.error('Unknown rule: ' + name);
            return '';
        }
        return Validation.rules[name](params, msg);
    },
    rules: {
        required(m) {
            return v => !!v || (m ? m : Vue.prototype.__('errors.required'));
        },
        requireBoolean(m) {
            return v => v !== undefined && v !== null || (m ? m : Vue.prototype.__('errors.required'));
        },
        requireMoney(m) {
            return v => !!v || (m ? m : Vue.prototype.__('errors.invalid_amount'));
        },
        positiveMoney(m) {
            return v => !!v && !v.startsWith('-') || (m ? m : Vue.prototype.__('errors.invalid_amount'));
        },
        requireNumber(m) {
            return v => !v || /^[0-9]+$/.test(v + '') || (m ? m : Vue.prototype.__('errors.number_required'));
        },
        requireOne(m) {
            return v => !!v && v.length > 0 || (m ? m : Vue.prototype.__('errors.required'));
        },
        requireMultiple(p, m) {
            //TODO use npm package sprintf-js to replace in translations
            return v => !!v && v.length >= p || (m ? m : 'Mindestens ' + p + ' auswählen');
        },
        email(m){
            return v => !!v && /(?:[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+)*|(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?\.)+[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?|\[(?:(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9]))\.){3}(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9])|[a-zA-Z0-9-]*[a-zA-Z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])/i.test(v) || (m ? m : Vue.prototype.__('errors.invalid_email'));
        },
        between() {
        },
        requireTrue(m) {
            return v => v===true || (m ? m : Vue.prototype.__('errors.required'));
        },
        dateAfter() {

        },
        dateBefore() {

        },
        minVal() {

        },
        maxVal(p, m) {
            //TODO use npm package sprintf-js to replace in translations
            return v => !v || v <= p || (m ? m : 'Maximum ' + p);
        },
        minLen() {

        },
        maxLen(p, m) {
            //TODO use npm package sprintf-js to replace in translations
            p = parseInt(p);
            return v => !v || v.length <= p || (m ? m : 'Höchstens ' + p + ' Zeichen');
        },
        length() {

        },
        match(p, m) {
            p = new RegExp('^' + p + '$');
            return v => p.test(v) || (m ? m : Vue.prototype.__('errors.invalid_characters'));
        },
    },
};
export default Validation;
